import VueDirective from '@/VueCore/directives/vueDirective';
import Tooltip from 'primevue/tooltip';
class PrimeVueTooltipDirective implements VueDirective {
  name = 'Tooltip';
  directive = Tooltip;
}

export default new PrimeVueTooltipDirective();